module.exports = __webpack_public_path__ + "static/media/25-speaker_profile.ea577037.webp";